import {Component} from '@angular/core';
import {Customer} from 'src/app/raintree/interface/customer-profile/customer';
import {GlobalService} from 'src/app/services/global.service';
import {BloomsightService} from "../../bloomsight.service";

@Component({
  selector: 'fb-profile-sidebar',
  templateUrl: './profile-sidebar.component.html',
  styleUrls: ['./profile-sidebar.component.scss']
})
export class ProfileSidebarComponent {
	constructor(
		public globalService: GlobalService,
		private _bloomsight: BloomsightService
	){

	}

	public userName = '';

	public ngOnInit(): void {
		// debugger

		this.globalService.customerProfile.subscribe((res: Customer)=>{
			this.userName = res.tenant.name
		})

		if(!this.userName && this.globalService.customerProfileData.tenant) this.userName = this.globalService.customerProfileData.tenant.name;
	}

	public trackOption(option: string) {
		this._bloomsight.trackDataEvent(
			'67c986eefa5f5a9c916076fb',
			[
				{option: option},
				{email: this.globalService.customerProfileData.tenant.email},
				{userId: this.globalService.customerProfileData.tenant.uid},
				{all: option + '-' + this.globalService.customerProfileData.tenant.email + '-' + this.globalService.customerProfileData.tenant.uid },
			],
			'User Profile Option'
		);
	}
}
